// extracted by mini-css-extract-plugin
export default {"toggle":"StatsFilter_toggle__JmF8a"};